import { Colors } from '../consts/Colors.js';

export const IntroData = {
    line1: {
        text: "Léo 2.0 a été conçu par :",
        config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 200 },
    },
    line2: {
        text: "Avec l’appui et le soutien de :",
        config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 200 },
    },
    line3: {
        text: "<class='boldCentury'>Remerciements : Lou Lubie </class>pour le style graphique illustratif et <class='boldCentury'>Claire Brancotte</class> pour le design graphique.",
        config: { size: '24px', fontFamily: 'CenturyGothic', align: 'center', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 1400 },
    },
    bigTitle: {
        text: "Bienvenue dans le module\n« <class='boldCentury'>Connaissances médicales</class> »\nde l'e-learning Léo 2.0.",
        config: { size: '60px', fontFamily: 'CenturyGothic', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 1400 },
    },
    soundText: {
        text: "Cet e-learning nécessite <class='boldCentury'>d’activer le son</class>.",
        config: { size: '36px', fontFamily: 'CenturyGothic', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 1400 },
    },
    items: [
        {
            content: {
                text: "Le <class='boldCentury'>Centre Lyonnais des Aidants en Psychiatrie (CLAP)</class>, une équipe pluridisciplinaire développant des programmes de psychoéducation à destination des aidants en psychiatrie.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 940 },
            },
            logo: "clapLogo",
            suppY: 0,
            logoY: 202
        },
        {
            content: {
                text: "Le CLAP est un service du <class='boldCentury'>Vinatier</class>, centre hospitalier engagé dans les soins et l’innovation en psychiatrie.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 940 },
            },
            logo: "leVinatierLogo",
            suppY: 105,
            logoY: 320
        },
        {
            content: {
                text: "La <class='boldCentury'>Fondation FondaMental</class>, pionnière dans la recherche en santé mentale.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 940 },
            },
            logo: "fondationFondamentalLogo",
            suppY: 250,
            logoY: 440
        },
        {
            content: {
                text: "<class='boldCentury'>Klésia</class>, acteur engagé dans l’assurance et la protection sociale.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 940 },
            },
            logo: "klesiaLogo",
            suppY: 340,
            logoY: 542
        },
        {
            content: {
                text: "L’<class='boldCentury'>Unafam</class>, acteur clé dans le soutien aux familles et proches de personnes ayant un trouble psychique.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 940 },
            },
            logo: "unafamLogo",
            suppY: 430,
            logoY: 633
        },
        {
            content: {
                text: "<class='boldCentury'>Sydo</class>, agence de conseil en pédagogies innovantes située à Lyon (ingénierie pédagogique, conception graphique et réalisation technique du module e-learning). ",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 940 },
            },
            logo: "sydoLogo",
            suppY: 540,
            logoY: 750
            // logoY: 854
        },
    ],
}

export const MenuData = [
    {
        index:1,
        illu: "A1",
        title: "Comment le cerveau fonctionne-t-il ?",
        content: "Découvrez dans cette vidéo le fonctionnement du cerveau et les origines des troubles psychiques.",
        nextActivite: "ActiviteA1",
        cardX: 1195,
        cardY: 510,
        illuX: 0,
        illuY: 0,
    },
    {
        index:2,
        illu: "A2",
        title: "Vulnérabilité et stress",
        content: "Naviguez dans cet outil interactif pour en apprendre plus sur le modèle stress-vulnérabilité qui permet d'expliquer l'apparition de troubles psychiques.",
        nextActivite: "ActiviteA2",
        cardX: 1545,
        cardY: 685,
        illuX: 0,
        illuY: -35,
    },
    {
        index:3,
        illu: "A3",
        title: "Les symptômes et diagnostics associés",
        content: "Cet outil interactif vous présente les méthodes utilisées pour poser un diagnostic sur un ou plusieurs symptômes.",
        nextActivite: "ActiviteA3",
        cardX: 1142,
        cardY: 830,
        illuX: 0,
        illuY: 0,
    },
    {
        index:4,
        illu: "B1",
        title: "Que se passe-t-il quand on prend un médicament ?",
        content: "Visionnez cette vidéo pour comprendre comment les médicaments agissent dans l'organisme et la signification de notions comme « résistance au traitement » .",
        nextActivite: "ActiviteB1",
        cardX: 1255,
        cardY: 510,
        illuX: 0,
        illuY: 0,
    },
    {
        index:5,
        illu: "B2",
        title: "Les traitements médicamenteux",
        content: "Parcourez cet outil interactif pour avoir un panorama des différents types de traitements médicamenteux qui existent pour réduire les symptômes des troubles et prévenir leur réapparition.",
        nextActivite: "ActiviteB2",
        cardX: 1548,
        cardY: 740,
        illuX: 0,
        illuY: 0,
    },
    {
        index:6,
        illu: "B3",
        title: "Les traitements non-médicamenteux",
        content: "Réalisez cette activité pour en apprendre plus sur les différents soins complémentaires aux traitements médicamenteux.",
        nextActivite: "ActiviteB3",
        cardX: 1140,
        cardY: 840,
        illuX: 0,
        illuY: 0,
    },
    {
        index:7,
        illu: "Renfo",
        title: "Le rétablissement",
        content: "Découvrez dans cet outil interactif en quoi consiste le rétablissement dans le domaine de la santé mentale.",
        nextActivite: "ActiviteConclu",
        cardX: 1580,
        cardY: 415,
        illuX: 0,
        illuY: 0,
    },
]

export const A2Data = {
    introTitle: {
        text: "Vulnérabilité et stress :\ncomment expliquer l'apparition de troubles psychiques ?".toUpperCase(),
        config: { size: '36px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 1600 },
    },
    introContent1: {
        text: "Dans cet outil, vous allez découvrir <class='boldCentury'>le modèle stress-vulnérabilité </class>qui permet d'expliquer <class='boldCentury'>pourquoi certaines personnes développent des troubles psychiques face à des facteurs de stress.</class>",
        config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 1600 },
    },
    introContent2: {
        text: "Pour parcourir cet outil, utilisez <class='boldCenturyBlue'>les boutons de navigation</class> et cliquez sur <class='boldCenturyRed'>le menu situé en haut de l'écran</class> pour recommencer une partie.",
        config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 1600 },
    },
    menuBtns: [
        {
            text: "VULNÉRABILITÉ",
            config: { size: '30px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 420 },
            index: 0
        },
        {
            text: "STRESS",
            config: { size: '30px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 420 },
            index: 1
        },
        {
            text: "QUAND VULNÉRABILITÉ ET STRESS SE RENCONTRENT",
            config: { size: '30px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 390 },
            index: 2
        },
    ],
    questionBlocks: [
        {
            questText: {
                text: "D'après vous, qu'entend-on par vulnérabilité ?",
                config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1600 },
            },
            repText1: {
                text: "C’est une faiblesse mentale permanente qui empêche les personnes de fonctionner normalement dans la société.",
                config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                isTrue: false
            },
            repText2: {
                text: "C'est une prédisposition individuelle à développer des troubles psychiques en cas de stress.",
                config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                isTrue: true
            },
            repText3: {
                text: "C’est une tendance à exagérer les problèmes ou à chercher l’attention des autres dans les situations difficiles.",
                config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                isTrue: false
            },
            feedBackTrue: {
                text: "Chaque personne est caractérisée par <class='boldCentury'>un niveau de fragilité personnel vis-à-vis des troubles psychiques :</class> on parle de « <class='boldCentury'>vulnérabilité</class> ».\n\nLa vulnérabilité <class='boldCentury'>varie d’une personne à l’autre</class>. Généralement, elle n’est pas suffisante pour déclencher à elle seule un trouble psychique, elle ne fait qu’augmenter le risque. \n\nPour que le trouble psychique apparaisse, il faut que <class='boldCentury'>la personne soit exposée à un environnement difficile.</class>",
                config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
            },
            feedBackFalse: {
                text: "Chaque personne est caractérisée par <class='boldCentury'>un niveau de fragilité personnel vis-à-vis des troubles psychiques :</class> on parle de « <class='boldCentury'>vulnérabilité</class> ».\n\nLa vulnérabilité <class='boldCentury'>varie d’une personne à l’autre</class>. Généralement, elle n’est pas suffisante pour déclencher à elle seule un trouble psychique, elle ne fait qu’augmenter le risque. \n\nPour que le trouble psychique apparaisse, il faut que <class='boldCentury'>la personne soit exposée à un environnement difficile.</class>",
                config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
            },
            feedBackImage: 'feedback1'

        },
        {
            questText: {
                text: "D'après vous, qu'est-ce que le stress ?",
                config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1600 },
            },
            repText1: {
                text: "C’est une réaction anormale du cerveau qui survient uniquement chez les personnes fragiles psychologiquement.",
                config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                isTrue: false
            },
            repText2: {
                text: "C’est un état d'esprit négatif que l'on peut éliminer simplement en pensant positivement.",
                config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                isTrue: false
            },
            repText3: {
                text: "C’est une réaction normale et naturelle du corps et du cerveau face à une situation perçue comme difficile ou incontrôlable.",
                config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                isTrue: true
            },
            feedBackTrue: {
                text: "Le stress est <class='boldCentury'>un ensemble de réactions de notre organisme</class> face à une situation perçue comme difficile, menaçante, imprévisible ou sur laquelle on a l'impression d'avoir peu de contrôle.\n\n<class='boldCentury'>Que se passe-t-il dans le corps ? </class>\n\nAu niveau biologique, le cerveau déclenche une alerte et libère des hormones du stress, comme <class='boldCentury'>l’adrénaline et le cortisol</class>. Ces substances<class='boldCentury'> accélèrent le rythme cardiaque, augmentent la vigilance et mobilisent l’énergie pour faire face à la situation. </class>\n\n<class='boldCentury'>Le stress est donc un mécanisme de protection :</class> il prépare l’organisme à faire face à un danger ou à un défi. Mais si cette réaction devient trop fréquente, trop intense ou trop prolongée, <class='boldCentury'>elle peut finir par nuire à l’équilibre physique et psychique.</class>",
                config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
            },
            feedBackFalse: {
                text: "Le stress est <class='boldCentury'>un ensemble de réactions de notre organisme</class> face à une situation perçue comme difficile, menaçante, imprévisible ou sur laquelle on a l'impression d'avoir peu de contrôle.\n\n<class='boldCentury'>Que se passe-t-il dans le corps ? </class>\n\nAu niveau biologique, le cerveau déclenche une alerte et libère des hormones du stress, comme <class='boldCentury'>l’adrénaline et le cortisol.</class> Ces substances <class='boldCentury'>accélèrent le rythme cardiaque, augmentent la vigilance et mobilisent l’énergie pour faire face à la situation.</class> \n\n<class='boldCentury'>Le stress est donc un mécanisme de protection :</class> il prépare l’organisme à faire face à un danger ou à un défi. Mais si cette réaction devient trop fréquente, trop intense ou trop prolongée, <class='boldCentury'>elle peut finir par nuire à l’équilibre physique et psychique.</class>",
                config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
            },
            feedBackImage: 'feedback2'
        },
    ],
    screens: {
        part1: [
            {
                questText: {
                    text: "D'après vous, qu'entend-on par vulnérabilité ?",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1600 },
                },
                repText1: {
                    text: "C’est une faiblesse mentale permanente qui empêche les personnes de fonctionner normalement dans la société.",
                    config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                    isTrue: false
                },
                repText2: {
                    text: "C'est une prédisposition individuelle à développer des troubles psychiques en cas de stress.",
                    config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                    isTrue: true
                },
                repText3: {
                    text: "C’est une tendance à exagérer les problèmes ou à chercher l’attention des autres dans les situations difficiles.",
                    config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                    isTrue: false
                },
                feedBackTrue: {
                    text: "Chaque personne est caractérisée par <class='boldCentury'>un niveau de fragilité personnel vis-à-vis des troubles psychiques :</class> on parle de « <class='boldCentury'>vulnérabilité</class> ».\n\nLa vulnérabilité <class='boldCentury'>varie d’une personne à l’autre</class>. Généralement, elle n’est pas suffisante pour déclencher à elle seule un trouble psychique, elle ne fait qu’augmenter le risque. \n\nPour que le trouble psychique apparaisse, il faut que <class='boldCentury'>la personne soit exposée à un environnement difficile.</class>",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                },
                feedBackFalse: {
                    text: "Chaque personne est caractérisée par <class='boldCentury'>un niveau de fragilité personnel vis-à-vis des troubles psychiques :</class> on parle de « <class='boldCentury'>vulnérabilité</class> ».\n\nLa vulnérabilité <class='boldCentury'>varie d’une personne à l’autre</class>. Généralement, elle n’est pas suffisante pour déclencher à elle seule un trouble psychique, elle ne fait qu’augmenter le risque. \n\nPour que le trouble psychique apparaisse, il faut que <class='boldCentury'>la personne soit exposée à un environnement difficile.</class>",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                },
                feedBackImage: 'feedback1'

            },
            {
                index: 0,
                part: 1,
                title: {
                    text: "La vulnérabilité est à la fois innée et acquise",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1600 },
                    titleX: 195,
                    titleY: 365

                },
                content: {
                    text: "Cliquez sur les cases pour en savoir plus.",
                    config: { size: '30px', fontFamily: 'CenturyGothicItalic', align: 'left', color: Colors.Text.TextBlue, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1600 },
                    contentX: 195,
                    contentY: 435
                },
                btn1: {
                    text: "INNÉE",
                    config: { size: '36px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 400 },
                    index: 0,
                    btn1X: 690,
                    btn1Y: 670
                },
                btn2: {
                    text: "ACQUIS",
                    config: { size: '36px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 400 },
                    index: 1,
                    btn2X: 1220,
                    btn2Y: 670
                },
            },
            {
                title: {
                    text: "La vulnérabilité est innée",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                    titleX: 195,
                    titleY: 365
                },
                content: {
                    text: "La vulnérabilité innée correspond à <class='boldCentury'>des facteurs présents dès la conception</class> qui rendent <class='boldCentury'>une personne plus sensible au stress, aux difficultés ou à des facteurs présents dans son environnement.</class>\n\nElle est principalement <class='boldCentury'>liée à la génétique d’un individu</class>, c'est-à-dire aux informations contenues dans son ADN.",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1090 },
                    contentX: 600,
                    contentY: 465
                },
                img: "screenA1",
                imgX: 374,
                imgY: 700,
                index: 1,
                part: 1,
            },
            {
                title: {
                    text: "Précisions sur les facteurs génétiques impliqués dans les troubles psychiques",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                    titleX: 195,
                    titleY: 365

                },
                content: {
                    text: "Chez une personne donnée, la vulnérabilité génétique aux troubles psychiques ne repose pas sur un seul gène (comme dans les maladies rares), mais elle est <class='boldCentury'>le résultat de l’influence de centaines, voire de milliers, de gènes</class>. Chacun de ces gènes <class='boldCentury'>augmente faiblement le risque de développer un trouble psychique</class> : on parle de<class='boldCentury'> maladies polygéniques </class>(= impliquant un grand nombre de gènes).\n\nDu point de vue de l’hérédité, <class='boldCentury'>ce n’est pas la maladie qui est transmise au sein de la famille, mais une fragilité.</class>\n\nException : la recherche progresse et on sait désormais que, <class='boldCentury'>pour une petite proportion de patients, un facteur génétique explique à lui seul le trouble</class>. Ce facteur n’est pas nécessairement transmis par les parents.  En effet, assez fréquemment, <class='boldCentury'>il est apparu spontanément</class> chez le patient « sans que ses parents en soient porteurs » (on dit qu’il est « de novo »).",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1200 },
                    contentX: 442,
                    contentY: 465
                },
                img: "screenA2",
                imgX: 272,
                imgY: 634,
                index: 2,
                part: 1,
            },
            {
                title: {
                    text: "La vulnérabilité est également acquise",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                    titleX: 195,
                    titleY: 365
                },
                content: {
                    text: "En effet, <class='boldCentury'>elle dépend aussi de l'environnement précoce</class>, c'est-à-dire de l’environnement au sens large, et <class='boldCentury'>des expériences vécues durant la grossesse, l'enfance et l'adolescence</class>, périodes cruciales pendant lesquelles le cerveau se développe.\n\nDe façon imagée : <class='boldCentury'>tout facteur susceptible de venir perturber la mécanique fine de maturation du cerveau augmente faiblement le niveau de vulnérabilité.</class>\n\nLes facteurs contribuant à la vulnérabilité acquise sont de nature variable et <class='boldCentury'>la plupart d’entre eux ne sont pas contrôlables par la famille</class> : infections fœtales, pollution, facteurs nutritionnels, grandir en zone urbaine, traumatismes (deuil, agression, abandon, séparation, abus…), contexte social et éducatif, etc.",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                    contentX: 600,
                    contentY: 465
                },
                img: "screenA3",
                imgX: 308,
                imgY: 663,
                index: 3,
                part: 1,
            },
            {
                title: {
                    text: "Stop aux idées reçues !",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                    titleX: 195,
                    titleY: 365
                },
                content: {
                    text: "Souvent les familles se questionnent sur ce qui aurait pu être fait différemment pour réduire la vulnérabilité de leur proche.\n\n<class='boldCentury'>En fait, cette vulnérabilité résulte de facteurs variés, souvent imprévisibles, non contrôlables et indépendants de la volonté de chacun : bagage génétique, parcours de vie, environnement...</class>",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                    contentX: 445,
                    contentY: 465
                },
                img: "screenA4",
                imgX: 281,
                imgY: 657,
                index: 4,
                part: 1,
            },
        ],
        part2: [
            {
                questText: {
                    text: "D'après vous, qu'est-ce que le stress ?",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1600 },
                },
                repText1: {
                    text: "C’est une réaction anormale du cerveau qui survient uniquement chez les personnes fragiles psychologiquement.",
                    config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                    isTrue: false
                },
                repText2: {
                    text: "C’est un état d'esprit négatif que l'on peut éliminer simplement en pensant positivement.",
                    config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                    isTrue: false
                },
                repText3: {
                    text: "C'est une réaction normale et naturelle du corps et du cerveau face à un environnement difficile ou incontrôlable.",
                    config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
                    isTrue: true
                },
                feedBackTrue: {
                    text: "Le stress est <class='boldCentury'>un ensemble de réactions de notre organisme</class> face à un environnement difficile, menaçant, imprévisible ou sur lequel on a l'impression d'avoir peu de contrôle.\n\n<class='boldCentury'>Que se passe-t-il dans le corps ? </class>\n\nAu niveau biologique, le cerveau déclenche une alerte et libère des hormones du stress, comme <class='boldCentury'>l’adrénaline et le cortisol.</class> Ces substances <class='boldCentury'>accélèrent le rythme cardiaque, augmentent la vigilance et mobilisent l’énergie pour faire face à la situation.</class> \n\n<class='boldCentury'>Le stress est donc un mécanisme de protection et d’adaptation :</class> il prépare l’organisme à faire face à un danger ou à un défi. Mais si cette réaction devient trop fréquente, trop intense ou trop prolongée, <class='boldCentury'>elle peut finir par nuire à l’équilibre physique et psychique.</class>",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                },
                feedBackFalse: {
                    text: "Le stress est <class='boldCentury'>un ensemble de réactions de notre organisme</class> face à un environnement difficile, menaçant, imprévisible ou sur lequel on a l'impression d'avoir peu de contrôle.\n\n<class='boldCentury'>Que se passe-t-il dans le corps ? </class>\n\nAu niveau biologique, le cerveau déclenche une alerte et libère des hormones du stress, comme <class='boldCentury'>l’adrénaline et le cortisol.</class> Ces substances <class='boldCentury'>accélèrent le rythme cardiaque, augmentent la vigilance et mobilisent l’énergie pour faire face à la situation.</class> \n\n<class='boldCentury'>Le stress est donc un mécanisme de protection et d’adaptation :</class> il prépare l’organisme à faire face à un danger ou à un défi. Mais si cette réaction devient trop fréquente, trop intense ou trop prolongée, <class='boldCentury'>elle peut finir par nuire à l’équilibre physique et psychique.</class>",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                },
                feedBackImage: 'feedback2'
            },
            {
                title: {
                    text: "Les facteurs de stress environnementaux ",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                    titleX: 195,
                    titleY: 365
                },
                content: {
                    text: "Les facteurs de stress environnementaux peuvent être de natures très diverses :",
                    config: { size: '26px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                    contentX: 600,
                    contentY: 465
                },
                img: "screenB1",
                imgX: 335,
                imgY: 635,
                bulletList: [
                    {
                        text: "un deuil,",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: false
                    },
                    {
                        text: "une naissance,",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: false
                    },
                    {
                        text: "un conflit,",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: false
                    },
                    {
                        text: "un déménagement,",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: false
                    },
                    {
                        text: "une situation de précarité,",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: false
                    },
                    {
                        text: "l’usage de substances comme l’alcool ou le cannabis,",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: false
                    },
                    {
                        text: "l’exposition à des facteurs environnementaux négatifs (pollution, carences nutritionnelles, infections…),",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1080 },
                        isLong: false
                    },
                    {
                        text: "etc.",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: true
                    },
                ],
                bulletX: 690,
                bulletY: 560,
                index: 5,
                part: 2,
            },
            {
                title: {
                    text: "Face à un même facteur de stress, l’impact sur l’individu est déterminé par son niveau de vulnérabilité ",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                    titleX: 195,
                    titleY: 365
                },
                content: {
                    text: "Ce qu’il faut surtout retenir, c’est que <class='boldCentury'>nous ne réagissons pas tous de manière identique face à un facteur de stress donné.</class>\n\n<class='boldCentury'>L’impact du stress dépend du niveau de vulnérabilité de chacun :</class> \ndeux personnes exposées au même facteur de stress n’en tireront pas les mêmes effets. Là où l’une va s’adapter, l’autre peut développer des symptômes selon ses fragilités préexistantes.\n\nPar exemple :",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                    contentX: 600,
                    contentY: 465
                },
                img: "screenB1",
                imgX: 335,
                imgY: 665,
                bulletList: [
                    {
                        text: "Deux personnes consomment <class='boldCentury'>du cannabis</class>. L'une n'aura aucun effet notable, alors que la deuxième pourra déclencher un premier épisode psychotique. ",
                        config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1000 },
                        isLong: false
                    },
                    {
                        text: "Après <class='boldCentury'>un attentat</class>, certaines personnes vont réussir à reprendre une vie sans impact particulier, tandis que d'autres développeront un trouble de stress post-traumatique.",
                        config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1000 },
                        isLong: true
                    },
                ],
                bulletX: 690,
                bulletY: 720,
                index: 6,
                part: 2,
            },
        ],
        part3: [
            {
                title: {
                    text: "Quand vulnérabilité et stress se rencontrent : le modèle stress-vulnérabilité",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1800 },
                    titleX: 195,
                    titleY: 365
                },
                content: {
                    text: "Le modèle stress-vulnérabilité est un cadre explicatif robuste, étayé par la recherche scientifique, utilisé en psychiatrie pour <class='boldCentury'>comprendre comment et pourquoi un trouble psychique peut apparaître chez une personne</class>.\n\nIl repose sur l’idée que <class='boldCentury'>le développement d’un trouble dépend de l’interaction entre les deux éléments</class> vus précédemment :",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                    contentX: 600,
                    contentY: 465
                },
                content2: {
                    text: "Pour bien le comprendre, nous allons utiliser <class='boldCenturyRed'>l'analogie du verre.</class>",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                    content2X: 600,
                    content2Y: 725
                },
                bulletList: [
                    {
                        text: "<class='boldCentury'>la vulnérabilité</class> (innée et/ou acquise),",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                    },
                    {
                        text: "<class='boldCentury'>les facteurs de stress</class>.",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                    },
                ],
                bulletX: 690,
                bulletY: 655,
                img: "screenC1",
                imgX: 366,
                imgY: 646,
                index: 7,
                part: 3,
            },
            {
                index: 8,
                part: 3,
                title: {
                    text: "Quand vulnérabilité et stress se rencontrent : l'analogie du verre",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1800 },
                    titleX: 195,
                    titleY: 365

                },
                content: {
                    text: "La vulnérabilité est comme un verre.",
                    config: { size: '30px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.TextOrange, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                    contentX: 680,
                    contentY: 430
                },
                content2: {
                    text: "<class='boldCentury'>Sa taille est déterminée à l'avance par des facteurs génétiques (= vulnérabilité innée).</class>\n\nOn n'y peut donc rien. On ne choisit pas la taille de son verre : certaines personnes ont un verre de petite taille, d'autres un plus grand…",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 530 },
                    content2X: 167,
                    content2Y: 590
                },
                content3: {
                    text: "<class='boldCentury'>Le niveau de base du liquide dans le verre est lié au vécu et à l'environnement dans lequel on a grandi (= vulnérabilité acquise).</class>\n\nCe niveau est donc là aussi propre à chacun.",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 530 },
                    content3X: 1245,
                    content3Y: 590
                },
                img: "screenC2",
                imgX: 740,
                imgY: 720,
                img2: "screenC3",
                img2X: 960,
                img2Y: 720,
                img3: "screenC4",
                img3X: 960,
                img3Y: 720,
                img4: "screenC5",
                img4X: 1170,
                img4Y: 780,
                content4: {
                    text: "En plus des facteurs de vulnérabilité,",
                    config: { size: '30px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.TextOrange, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                    content4X: 195,
                    content4Y: 430
                },
                content5: {
                    text: "les facteurs de stress agissent comme des fioles de liquide qui se\n\t\tdéversent dans le verre.",
                    config: { size: '30px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.TextOrange, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1000 },
                    content5X: 730,
                    content5Y: 430
                },
                content6: {
                    text: "Au cours de la vie, on est confronté à des facteurs de stress. Ces derniers diffèrent d'une personne à l'autre et chacun y réagit différemment. Ils peuvent être :",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 720 },
                    content6X: 970,
                    content6Y: 536
                },
                content7: {
                    text: "En fonction de la taille du verre (qui correspond à <class='boldCentury'>la vulnérabilité innée</class>) et du niveau initial du liquide (représentant <class='boldCentury'>la vulnérabilité acquise</class>), il faut une quantité de stress plus ou moins importante pour le faire déborder.\n\n<class='centuryBlue'>Avancez le curseur vers la droite pour découvrir des exemples de facteurs de stress.</class>",
                    config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 500 },
                    content7X: 195,
                    content7Y: 430
                },

                bulletList: [
                    {
                        text: "« <class='boldCentury'>psychologiques</class> » positifs ou négatifs (deuil, séparation, surmenage, naissance, mariage…),",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 700 },
                        isLong: false
                    },
                    {
                        text: "mais aussi « <class='boldCentury'>biologiques</class> » (consommation de drogues, alcool, problèmes de santé physiques, troubles du sommeil…). ",
                        config: { size: '26px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 700 },
                        isLong: true
                    },
                ],
                bulletX: 975,
                bulletY: 660,

                img5: "facteursVulnerabilite",
                img5X: 662,
                img5Y: 893,
                img6: "screenC6",
                img6X: 655,
                img6Y: 600,
                img7: "facteursStress",
                img7X: 717,
                img7Y: 670,
                img8: "screenC7",
                img8X: 880,
                img8Y: 560,


                title2: {
                    text: "Quand le verre est plein... il déborde !",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1800 },
                    titleX: 195,
                    titleY: 365
                },
                content8: {
                    text: "<class='boldCentury'>Lorsqu'il déborde, cela signifie que des symptômes de troubles psychiques apparaissent, pouvant marquer l'entrée (ou la rechute) dans la maladie.</class>\n\nSelon la vulnérabilité de la personne, une quantité plus ou moins importante de facteurs de stress est nécessaire pour faire « déborder le verre » :",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 545 },
                    content8X: 195,
                    content8Y: 430
                },
                bulletList2: [
                    {
                        text: "chez les personnes plus vulnérables, quelques événements peuvent suffire ;",
                        config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 545 },
                        isLong: false
                    },
                    {
                        text: "chez celles moins vulnérables, une accumulation plus importante est souvent nécessaire.",
                        config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 545 },
                        isLong: true
                    },
                ],
                bullet2X: 195,
                bullet2Y: 680,
                img9: "screenC8",
                img9X: 786,
                img9Y: 700,
            },
            // {
            //     title: {
            //         text: "Quand le verre est plein... il déborde !",
            //         config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1800 },
            //         titleX: 195,
            //         titleY: 365
            //     },
            //     content: {
            //         text: "<class='boldCentury'>Cela signifie que des symptômes de troubles psychiques apparaissent, pouvant marquer l'entrée (ou la rechute) dans la maladie.</class>\n\nSelon la vulnérabilité de la personne, une quantité plus ou moins importante de facteurs de stress est nécessaire pour faire « déborder le verre » :",
            //         config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 545 },
            //         contentX: 195,
            //         contentY: 430
            //     },
            //     bulletList: [
            //         {
            //             text: "chez les personnes plus vulnérables, quelques événements peuvent suffire ;",
            //             config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 545 },
            //             isLong: false
            //         },
            //         {
            //             text: "chez celles moins vulnérables, une accumulation plus importante est souvent nécessaire.",
            //             config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 545 },
            //             isLong: true
            //         },
            //     ],
            //     bulletX: 195,
            //     bulletY: 670,
            //     index: 8,
            //     part: 3,
            //     img: "screenC8",
            //     imgX: 786,
            //     imgY: 700,
            // },
            {
                title: {
                    text: "Pour conclure",
                    config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1800 },
                    titleX: 195,
                    titleY: 365
                },
                content: {
                    text: "Ce n’est pas le stress seul, ni la vulnérabilité seule, qui explique les troubles, mais <class='boldCentury'>l’interaction entre les deux :\n\t\t-> Vulnérabilité élevée + stress important = risque élevé de développer un trouble psychique</class>.\n\nLe modèle stress-vulnérabilité est utile, car :",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                    contentX: 445,
                    contentY: 450
                },
                content2: {
                    text: "<class='boldCentury'>Il rappelle aussi</class> une chose essentielle : la vulnérabilité et les facteurs de stress sont souvent imprévisibles, aléatoires et non maîtrisables. Ce modèle évite les jugements et la culpabilisation : <class='boldCentury'>personne n’est « responsable »</class>, ce qui compte c’est de pouvoir être accompagné.",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
                    content2X: 445,
                    content2Y: 805
                },
                img: "screenC10",
                imgX: 245,
                imgY: 650,
                bulletList: [
                    {
                        text: "Il aide à <class='boldCentury'>comprendre pourquoi certaines personnes développent un trouble face à des facteurs de stress</class>, et d'autres non.",
                        config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: false
                    },
                    {
                        text: "Il permet de <class='boldCentury'>comprendre les stratégies thérapeutiques en psychiatrie</class> avec : ",
                        config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: true
                    },
                ],
                bulletX: 530,
                bulletY: 600,
                bulletList2: [
                    {
                        text: "<class='boldCentury'>les traitements médicamenteux</class> qui permettent de contenir la vulnérabilité,",
                        config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: false
                    },
                    {
                        text: "<class='boldCentury'>les thérapeutiques non médicamenteuses</class> dont l’objectif est de réduire le risque d’exposition aux facteurs de stress ou de diminuer leur impact.",
                        config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 },
                        isLong: false
                    },
                ],
                bullet2X: 580,
                bullet2Y: 700,
                index: 10,
                part: 3,
            }
        ],
    },
    sliderCtnt: [
        {
            text: "ISOLEMENT",
            config: { size: '26px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.GrayTxt, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 150 },
            ctntX: 814,
            ctntY: 835
        },
        {
            text: "MAUVAISE NOUVELLE",
            config: { size: '26px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.GrayTxt, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 150 },
            ctntX: 742,
            ctntY: 691
        },
        {
            text: "PROBLÈME DE SANTÉ",
            config: { size: '26px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.GrayTxt, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 150 },
            ctntX: 763,
            ctntY: 515
        },
        {
            text: "MANQUE DE SOMMEIL",
            config: { size: '26px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.GrayTxt, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 150 },
            ctntX: 885,
            ctntY: 431
        },
        {
            text: "ÉVÉNEMENT DE VIE",
            config: { size: '26px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.GrayTxt, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 200 },
            ctntX: 1204,
            ctntY: 430
        },
        {
            text: "TOXIQUES",
            config: { size: '26px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.GrayTxt, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 150 },
            ctntX: 1377,
            ctntY: 540
        },
        {
            text: "ANXIÉTÉ",
            config: { size: '26px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.GrayTxt, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 150 },
            ctntX: 1467,
            ctntY: 639
        },
        {
            text: "SURMENAGE",
            config: { size: '26px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.GrayTxt, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 150 },
            ctntX: 1485,
            ctntY: 790
        },
    ]
}

export const B2Data = {
    btns: [
        {
            y: 194,
            title: "<class='butterfly'>DE FOND</class>\n<class='size24'>au long cours</class>",
            funct: "secondScreen",
            isMulti: true,
            index: 0,
            txtBtns: [
                {

                    text: "ANTIPSYCHOTIQUES OU\nNEUROLEPTIQUES",
                    config: { size: '30px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 300 },
                    funct: "thirdScreen"
                },
                {
                    text: "ANTIDÉPRESSEURS",
                    config: { size: '30px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 300 },
                    funct: "fourthScreen"
                },
                {
                    text: "THYMORÉGULATEURS",
                    config: { size: '30px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 300 },
                    funct: "fifthScreen"
                },
            ],
            btnSpace: 355
        },
        {
            y: 378,
            title: "<class='butterfly'>SÉDATIFS</class>\n<class='size24'>en général limité à la période de crise</class>",
            funct: "sixthScreen",
            isMulti: false,
            index: 1,
            txtBtns: undefined
        },
        {
            y: 559,
            title: "<class='butterfly'>CORRECTEURS</class>\n<class='size24'>associés au traitement, pour limiter ses effets négatifs</class>",
            funct: "seventhScreen",
            isMulti: false,
            index: 2,
            txtBtns: undefined
        },
        {
            y: 740,
            title: "<class='butterfly'>D'APPOINT</class>\n<class='size24'>des traitements ponctuels</class>",
            funct: "heightScreen",
            isMulti: true,
            index: 3,
            txtBtns: [
                {
                    text: "ANXIOLYTIQUES",
                    config: { size: '30px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 300 },
                    funct: "ninethScreen"
                },
                {
                    text: "HYPNOTIQUES OU\nSOMNIFÈRES",
                    config: { size: '30px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 300 },
                    funct: "tenthScreen"
                },
            ],
            btnSpace: 525
        },
    ],
    screens: {
        screen1: {
            txt1: {
                text: "Il existe <class='boldCentury'>différents types de traitements médicamenteux.</class>",
                config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1080 }
            },
            txt2: {
                text: "Découvrez l’objectif et l’utilité de chacun.",
                config: { size: '30px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1080 }
            },
            txt3: {
                text: "Cliquez sur chacun des traitements à gauche pour en savoir plus.",
                config: { size: '30px', fontFamily: 'CenturyGothicItalic', align: 'left', color: Colors.Text.TextBlue, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1080 }
            },
            txt4: {
                text: "Il est normal d’essayer un traitement et de les ajuster en fonction des effets ressentis.",
                config: { size: '30px', fontFamily: 'CenturyGothicItalic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1080 }
            },
        },
        screen2: {
            title: {
                text: "Les traitements de fond",
                config: { size: '30px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1010 }
            },
            txt1: {
                text: "Ils ont vocation à rétablir l’équilibre chimique dans le cerveau : <class='boldCentury'>réguler les excès ou les déficits de neurotransmetteurs</class> (ex : dopamine) et ainsi traiter le symptôme associé.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 960 }
            },
            txt2: {
                text: "Ce sont des traitements <class='boldCentury'>au long cours, qui mettent un certain temps avant d’agir</class>. Ils peuvent donc être complétés par des traitements qui agissent rapidement (traitements sédatifs).",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1010 }
            },
            txt3: {
                text: "Il en existe <class='boldCentury'>3 grandes familles.</class>",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1010 }
            },
            txt4: {
                text: "Cliquez sur chacune des famille ci-dessus pour en savoir plus.",
                config: { size: '24px', fontFamily: 'CenturyGothicItalic', align: 'left', color: Colors.Text.TextOrange, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1010 }
            },
            txt5: {
                text: "Comme des chaussures de randonnée : il faut toujours en porter ; et si elles ne sont plus efficaces, il faut en changer.",
                config: { size: '24px', fontFamily: 'CenturyGothicItalic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 860 }
            },
        },
        screen3: {
            txt1: {
                text: "Quels sont les effets des antipsychotiques ou neuroleptiques ?",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt2: {
                text: "Ils peuvent être pris sous forme <class='boldCentury'>orale </class>(liquide ou solide) ou d’<class='boldCentury'>injection</class>.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt3: {
                text: "Quelques exemples :",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt4: {
                text: "Ces traitements <class='boldCentury'>mettent 3 à 4 semaines avant d’agir</class>. En période de crise, des antipsychotiques ou neuroleptiques sédatifs peuvent être recommandés.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            bulletList1: [
                {
                    text: "<class='boldCentury'>Freiner la transmission de dopamine dans le cerveau</class>",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "<class='boldCentury'>Diminuer les symptômes positifs</class> (hallucinations, délires, etc.) et <class='boldCentury'>la désorganisation</class>",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Réguler l’humeur",
                    config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Sédater",
                    config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Prévenir les rechutes",
                    config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },

            ],
            bulletList2: [
                {
                    text: "Aripiprazole (ABILIFY®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Olanzapine (ZYPREXA®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Rispéridone (RISPERDAL®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Quétiapine (XEROQUEL®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Clozapine (LEPONEX®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],

        },
        screen4: {
            txt1: {
                text: "Quels sont les effets des antidépresseurs ?",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt2: {
                text: "Quelques exemples :",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            bulletList1: [
                {
                    text: "Diminuer l'intensité de la dépression et réduire l'anxiété",
                    config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Prévenir les rechutes",
                    config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],
            bulletList2: [
                {
                    text: "Paroxétine (DEROXAT®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Citalopram (SEROPRAM®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],
            bulletList3: [
                {
                    text: "Escitalopram (SEROPLEX®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],
            bulletList4: [
                {
                    text: "Sertraline (ZOLOFT®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Fluoxétine (PROZAC®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],
        },
        screen5: {
            txt1: {
                text: "Quels sont les effets des thymorégulateurs ?",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt2: {
                text: "Quelques exemples :",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt3: {
                text: "ANTIÉPILÉPTIQUES",
                config: { size: '30px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt4: {
                text: "ANTIPSYCHOTIQUES\nATYPIQUES",
                config: { size: '30px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            bulletList1: [
                {
                    text: "<class='boldCentury'>Réduire l'intensité, la fréquence, la durée des épisodes</class> (maniaques, hypomaniaques, dépressifs)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 800 }
                },
                {
                    text: "Améliorer la qualité de vie entre les période de « crise » ",
                    config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Prévenir les rechutes",
                    config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],
            bulletList2: [
                {
                    text: "Lithium (TERALITHE®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],
            bulletList3: [
                {
                    text: "Valproate (DÉPAKOTE-MIDE-KINE®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 340 }
                },
                {
                    text: "Lamotrigine (LAMICTAL®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 340 }
                },
                // {
                //     text: "(LAMICTAL®)",
                //     config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 340 }
                // },
                {
                    text: "Carbamazépine (TÉGRÉTOL®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 340 }
                },
                // {
                //     text: "(TÉGRÉTOL®)",
                //     config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 340 }
                // },
            ],
            bulletList4: [
                {
                    text: "Aripiprazole  (ABILIFY®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Olanzapine (ZYPREXA®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Rispéridone (RISPERDAL®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Quétiapine (XÉROQUEL®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],

        },
        screen6: {
            title: {
                text: "Les traitements sédatifs",
                config: { size: '30px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt1: {
                text: "Ils sont généralement utilisés <class='boldCentury'>en période de crise</class> (en attendant que le traitement de fond soit efficace) et permettent de calmer rapidement certains symptômes.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 980 }
            },
            txt2: {
                text: "On parle d’<class='boldCentury'>antipsychotiques ou neuroleptiques sédatifs.</class>",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt3: {
                text: "Quelques exemples :",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt4: {
                text: "Ils fonctionnent comme la barre de céréales, utilisée en cas d'hypoglycémie.",
                config: { size: '24px', fontFamily: 'CenturyGothicItalic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 880 }
            },
            bulletList1: [
                {
                    text: "Cyamémazine (TERCIAN®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 800 }
                },
                {
                    text: "Lévopromazine (NOZINAN®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Loxapine (LOXAPAC®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],
        },
        screen7: {
            title: {
                text: "Les traitements correcteurs",
                config: { size: '30px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt1: {
                text: "Ils permettent de <class='boldCentury'>limiter certains effets négatifs d’autres traitements</class> comme les contractures musculaires, les impatiences (besoin impérieux de bouger les membres), les tremblements, la sécheresse buccale, etc.\nIls sont fréquemment utilisés en début de traitement.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 980 }
            },
            txt2: {
                text: "Quelques exemples :",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt3: {
                text: "Ils fonctionnent comme la crème solaire, utilisée pour limiter les effets néfastes du soleil.",
                config: { size: '24px', fontFamily: 'CenturyGothicItalic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 880 }
            },
            bulletList1: [
                {
                    text: "Tropatépine (LEPTICUR®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 800 }
                },
                {
                    text: "Trihexyphénidyle (PARKINANE LP®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Anétholtrithione ( SULFARLEM ®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "AEQUASYAL®",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],
        },
        screen8: {
            title: {
                text: "Les traitements d’appoint",
                config: { size: '30px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt1: {
                text: "Ce sont des traitements ponctuels, par exemple pour gérer les troubles du sommeil ou l’anxiété.\nIls appartiennent la plupart du temps à la famille des benzodiazépines.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 980 }
            },
            txt2: {
                text: "Cliquez sur chacune des famille ci-dessous pour en savoir plus.",
                config: { size: '24px', fontFamily: 'CenturyGothicItalic', align: 'left', color: Colors.Text.TextOrange, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt3: {
                text: "Comme des bâtons de marches, ils peuvent être utiles en soutien de manière ponctuelle.",
                config: { size: '24px', fontFamily: 'CenturyGothicItalic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 880 }
            },
        },
        screen9: {
            txt1: {
                text: "Quels sont les effets des anxiolytiques ?",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt2: {
                text: "Les anxiolytiques présentent un <class='boldCentury'>risque d’accoutumance</class> (besoin d’augmenter la dose) avec un phénomène de dépendance, ce qui n’est pas le cas pour les antidépresseurs. Quelques exemples :",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt3: {
                text: "Quelle est la différence entre un anxiolytique et un antidépresseur ?",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt4: {
                text: "L'anxiolytique <class='boldCentury'>soulage rapidement</class> un symptôme : l’anxiété, alors que l’antidépresseur prend plus de temps pour agir et agit non seulement sur l’anxiété mais aussi sur d’autres symptômes en même temps.",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            bulletList1: [
                {
                    text: "Soulage rapidement l’angoisse et l’anxiété",
                    config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                }
            ],

            bulletList2: [
                {
                    text: "Bromazépam (LEXOMIL®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Prazépam (LYSANXIA®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Lorazépam (TEMESTA®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Oxazépam (SERESTA®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Alprazolam (XANAX®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],

        },
        screen10: {
            txt1: {
                text: "Quels sont les effets des hypnotiques ou somnifères ?",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            txt2: {
                text: "Ils présentent <class='boldCentury'>un risque de dépendance</class>, ils sont ainsi prescrits pour une durée inférieure à 28 jours. Quelques exemples :",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },

            bulletList1: [
                {
                    text: "Facilitent le sommeil",
                    config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                }
            ],

            bulletList2: [
                {
                    text: "Lormétazépam (NOCTAMIDE®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Zolpidem (STILNOX®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
                {
                    text: "Zopiclone (IMOVANE®)",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
                },
            ],

        },
        screen11: {
            title: {
                text: "Comment s’articulent les traitements de fond et/ou sédatifs ?",
                config: { size: '30px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1040 }
            },
            subtitle1: {
                text: "En période\nde crise",
                config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 1040 }
            },
            txt1: {
                text: "Introduction d’un <class='boldCentury'>traitement de fond</class> (dont l’efficacité apparaît en 3-4 semaines)\nIntroduction d’un <class='boldCentury'>traitement sédatif</class> le temps que le traitement de fond soit efficace",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 565 }
            },
            subtitle2: {
                text: "En prévention\nd’une rechute",
                config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 1040 }
            },
            txt2: {
                text: "<class='boldCentury'>Traitement de fond</class> maintenu à la dose minimale efficace",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 545 }
            },
            subtitle3: {
                text: "En période de\ndéstabilisation",
                config: { size: '24px', fontFamily: 'CenturyGothicBold', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 1040 }
            },
            txt3: {
                text: "Augmentation du <class='boldCentury'>traitement de fond</class>\net/ou\nintroduction/augmentation du <class='boldCentury'>traitement sédatif</class>",
                config: { size: '24px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 545 }
            },
        }
    }
}

export const B3Data = {
    activiteTitle: "LES TRAITEMENTS NON MÉDICAMENTEUX",
    introTitle: "Quels soins pour compléter les traitements médicamenteux ?",
    introContent: "Pour être optimale, la prise en charge thérapeutique doit nécessairement combiner des traitements médicamenteux à des <class='boldCentury'>approches non médicamenteuses</class>, des <class='boldCentury'>soins de réhabilitation psychosociale</class> mais aussi des <class='boldCentury'>interventions centrées sur l’hygiène de vie</class>, en fonction des besoins de chaque patient. \nToutes ces approches contribuent au processus de rétablissement qui correspond au parcours personnel vers une vie satisfaisante au-delà des symptômes.\n\nPour y voir plus clair, retrouve l’approche non médicamenteuse dont parle chaque personnage.",
    endTitle: "Et au-delà des soins : tout ce qui compte aussi",
    endSubTitle: "En complément des soins, d’autres facteurs jouent <class='boldCentury'>un rôle essentiel dans l’équilibre psychique.</class>",
    answers: [
        {
            titre: 'Psychothérapie (EMDR)',
            index: 0
        },
        {
            titre: 'Psychothérapie (TCC)',
            index: 1
        },
        {
            titre: 'Remédiation Cognitive',
            index: 2
        },
        {
            titre: 'Psychoéducation',
            index: 3
        },
        {
            titre: 'Gestion du stress',
            index: 4
        },
        {
            titre: 'Neurostimulation (ECT) ',
            index: 5
        },
        {
            titre: 'Neurostimulation (rTMS)',
            index: 6
        },
    ],
    questions: [
        {
            illu: 'b3MadameVielle',
            questionContent: 'Ce que j’apprécie, c’est qu’on prend le temps de revenir sur ce que j’ai vécu, mais aussi sur mes pensées et mes réactions. Parfois, ça remue, mais je comprends mieux certains mécanismes en moi. Je me sens plus armée face aux situations qui me faisaient perdre pied avant.',
            rightAnswer: 1,
            feedBack: "La psychothérapie peut s’appuyer sur différentes approches, comme les <class='boldCentury'>TCC (thérapies cognitivo-comportementales)</class>, qui sont des <class='boldCentury'>thérapies brèves, structurées, centrées sur l’ici et maintenant</class>, en travaillant sur les interactions entre pensées, émotions et comportements."
        },
        {
            illu: 'b3MonsieurCasque',
            questionContent: 'Pendant les séances, je repense à certaines situations qui me dérangent et en même temps je suis un mouvement des yeux ou je ressens un petit rythme alterné. Je ne sais pas exactement comment ça marche, mais avec le temps, ce qui me pesait autant devient plus flou, moins envahissant. J’ai l’impression que ça bouge à l’intérieur, même si je ne mets pas toujours les mots.',
            rightAnswer: 0,
            feedBack: "La psychothérapie peut s’appuyer sur différentes approches comme l’EMDR (Eye Movement Desensitization and Reprocessing) Elle repose sur la <class='boldCentury'>stimulation bilatérale </class>(mouvements oculaires, sons ou tapotements alternés), pendant que la personne repense à des <class='boldCentury'>souvenirs perturbants</class>. Cette technique permet de<class='boldCentury'> \"retraiter\" l’information </class>liée à l’événement douloureux, pour qu’elle perde son caractère envahissant."
        },
        {
            illu: 'b3MadameCasquette',
            questionContent: 'Avant, j’avais du mal à me concentrer ou à suivre une conversation trop longue. On fait des exercices ensemble, parfois sur ordi, parfois sur papier. Ce ne sont pas juste des jeux : ça m’aide à retrouver des repères. J’arrive mieux à m’organiser et je me sens un peu plus sûr de moi au quotidien.',
            rightAnswer: 2,
            feedBack: "La remédiation cognitive vise à améliorer certaines fonctions cognitives comme l’attention, la mémoire, la concentration ou les capacités d’organisation.\nElle repose sur des exercices spécifiques et peut inclure des stratégies concrètes à utiliser dans la vie quotidienne.\nL’objectif est d’aider la personne à mieux fonctionner au quotidien, en renforçant ses compétences ou en contournant certaines difficultés."
        },
        {
            illu: 'b3MonsieurEcharpe',
            questionContent: 'J’avais l’impression de subir ce que je vivais, sans comprendre. Pendant les séances, on m’a expliqué comment fonctionne le trouble, les signes d’alerte, et ce que je peux faire pour éviter que ça déborde. C’est pas juste de l’info : on apprend à repérer, à gérer, à réagir autrement. J’ai l’impression d’avoir enfin des outils en main.',
            rightAnswer: 3,
            feedBack: "La psychoéducation est un <class='boldCentury'>soin</class>  qui repose sur un processus d’apprentissage. Elle permet à la personne concernée, et/ou à ses proches, <class='boldCentury'>d’acquérir des connaissances et des compétences</class> pour mieux comprendre le trouble, ses symptômes, ses conséquences, et les stratégies pour y faire face."
        },
        {
            illu: 'b3MonsieurLunettes',
            questionContent: 'J’étais vraiment à bout, rien ne fonctionnait. On m’a proposé un traitement à l’hôpital, avec des séances sous anesthésie. Je ne me souviens pas de la séance en elle-même, mais au bout de quelques semaines, j’ai senti un changement. Ça m’a permis de remonter la pente.',
            rightAnswer: 5,
            feedBack: "L’électroconvulsivothérapie (ECT) est un <class='boldCentury'>soin médical encadré</class>, indiqué notamment dans <class='boldCentury'>certaines formes de dépression sévère ou résistantes</class>. Elle consiste à induire une brève stimulation cérébrale contrôlée, sous anesthésie générale. Souvent entourée d’idées reçues, elle est aujourd’hui pratiquée de manière sécurisée, avec un suivi attentif de l’équipe soignante."
        },
        {
            illu: 'b3MonsieurGratteLaTete',
            questionContent: 'Je venais tous les jours à l’hôpital pendant quelques semaines. On plaçait un appareil près de ma tête, ça faisait des petits claquements, mais ce n’était pas douloureux. J’ai commencé à sentir que mon esprit était plus clair, que j’étais plus présent.',
            rightAnswer: 6,
            feedBack: "La stimulation magnétique transcrânienne répétitive (rTMS) est un <class='boldCentury'>soin non invasif</class>, utilisé par exemple dans les troubles dépressifs ou les hallucinations.\nElle consiste à <class='boldCentury'>délivrer des impulsions magnétiques ciblées</class> sur certaines zones du cerveau, à travers le cuir chevelu.\nRéalisée sans anesthésie, la rTMS est bien tolérée et représente une alternative thérapeutique intéressante lorsque les traitements médicamenteux ne suffisent pas."
        },
        {
            illu: 'b3MadameTresse',
            questionContent: 'J’ai appris à m’arrêter, à respirer autrement, à me recentrer quand je sens que ça monte. Au début, j’avais du mal à y croire, mais maintenant c’est devenu un réflexe. Je prends quelques minutes chaque jour et ça change vraiment la façon dont je vis les moments de tension.',
            rightAnswer: 4,
            feedBack: "Les techniques de gestion du stress regroupent des pratiques simples et accessibles, comme <class='boldCentury'>la relaxation, la respiration consciente, ou la méditation de pleine conscience.</class>\nCe sont de véritables outils de soin qui permettent de mieux réguler les émotions, de réduire l’anxiété et de prévenir l’épuisement.\nApprises en séance, les techniques peuvent être réutilisées de manière autonome dans la vie quotidienne et s’intègrent souvent dans une démarche globale de bien-être psychique."
        },
    ],
    endBlocks: [
        {
            title: 'Prendre soin de son hygiène de vie',
            bullets: [
                {
                    illu: 'b3EndRythmeRegulier',
                    content: 'Rythme veille sommeil régulier'
                },
                {
                    illu: 'b3EndAlimentationEquilibree',
                    content: 'Alimentation équilibrée'
                },
                {
                    illu: 'b3EndActivitePhysique',
                    content: 'Activité physique adaptée'
                },
            ],
            // lastLine: 'Renforcer l’énergie, la concentration, l’humeur et le sentiment de stabilité',
            startingY: 180,
            bulletSpace: 120
        },
        {
            title: 'Bénéficier d’un soutien social',
            bullets: [
                {
                    illu: 'b3EndMaintenirLesLiens',
                    content: 'Maintenir des liens'
                },
                {
                    illu: 'b3EndSAppuyerSurLesProches',
                    content: 'Pouvoir s’appuyer sur des proches'
                },
                {
                    illu: 'b3EndSentimentDAppartenance',
                    content: 'Retrouver un sentiment d’appartenance'
                },
            ],
            lastLine: 'Facteurs protecteurs majeurs face à la souffrance',
            startingY: 180,
            bulletSpace: 120
        },
        {
            title: 'Rythmer le quotidien',
            bullets: [
                {
                    illu: 'b3EndLoisirsCreativite',
                    content: 'S\'accorder des moments de plaisir, de création ou de détente (loisirs, activités personnelles)'
                },
                {
                    illu: 'b3EndActiviteProfessionnelles',
                    content: 'Activités professionnelles'
                },
            ],
            lastLine: 'Moteurs de réengagement dans la vie',
            startingY: 210,
            bulletSpace: 150
        },
    ]
}

export const ConcluData = {
    screen1: {
        title: {
            text: "Le rétablissement".toUpperCase(),
            config: { size: '48px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        subtitle: {
            text: "Qu'est-ce que c'est ?",
            config: { size: '36px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        content: {
            text: "Comme nous l'avons vu tout au long de cet e-learning, la prise en charge thérapeutique d'un trouble psychique nécessite de combiner prises de médicaments, traitements non médicamenteux, soins de réhabilitation psychosociale, mais aussi des actions plus personnelles de la part de la personne (prendre soin de son hygiène de vie, rechercher un soutien social, rythmer son quotidien)... <class='boldCentury'>Tout cela pour tendre vers l'équilibre psychique et le rétablissement.</class>\n\nEn effet, en santé mentale, on ne parle pas de « guérison », mais de « <class='boldCentury'>rétablissement</class> ».\n\n<class='boldCentury'>Le rétablissement ne signifie pas guérir complètement, c'est-à-dire ne plus être porteur de troubles psychiques, mais retrouver une vie satisfaisante et riche, malgré l'existence de ces troubles.</class>",
            config: { size: '28px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 850 },
        },
        illu: [
            {
                img: "concluPersoRando",
                imgX: 456,
                imgY: 687
            },
            {
                img: "concluBulleVoyage",
                imgX: 309,
                imgY: 500
            },
            {
                img: "concluBulleAmour",
                imgX: 638,
                imgY: 454
            },
            {
                img: "concluBulleMain",
                imgX: 701,
                imgY: 638
            },
        ]
    },
    screen2: {
        title: {
            text: "Le rétablissement".toUpperCase(),
            config: { size: '48px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        subtitle: {
            text: "Un chemin personnel et progressif",
            config: { size: '36px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        content: {
            text: "Le rétablissement est comme un parcours, un chemin : sur ce chemin, il y a des périodes où l’on va bien et des périodes où l’on va moins bien. <class='boldCentury'>Plus on avance sur ce chemin, plus il y a des moments où l’on va bien</class>. \n\nChaque personne avance <class='boldCentury'>à son rythme</class>, étape par étape, en développant ses ressources, en surmontant les difficultés et en trouvant des appuis.",
            config: { size: '28px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 850 },
        },
        illu: [
            {
                img: "concluChemin",
                imgX: 513,
                imgY: 750
            },
            {
                img: "concluSmallPersoRando1",
                imgX: 125,
                imgY: 698
            },
            {
                img: "concluSmallPersoRando2",
                imgX: 593,
                imgY: 465
            },
            {
                img: "concluSmallPersoRando3",
                imgX: 665,
                imgY: 834
            },
        ]
    },
    screen3: {
        title: {
            text: "Le rétablissement".toUpperCase(),
            config: { size: '48px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        subtitle: {
            text: "Le patient est au centre du parcours de rétablissement",
            config: { size: '36px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        content: {
            text: "Le patient n’est pas réduit à son diagnostic. \n\nLe rétablissement vise à lui <class='boldCentury'>redonner le pouvoir d’agir</class> pour qu'il puisse construire un projet de vie qui fait sens pour lui (travail, études, relations, loisirs, logement…). \n\n<class='boldCentury'>Il est donc pleinement acteur de son parcours, avec l’aide des soignants, de sa famille, de ses proches, et parfois de pairs ayant vécu une expérience similaire</class>.",
            config: { size: '28px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 850 },
        },
        illu: [
            {
                img: "concluPersoRandoMuscles",
                imgX: 500,
                imgY: 640
            },
            {
                img: "concluSoignant",
                imgX: 248,
                imgY: 552
            },
            {
                img: "concluFille",
                imgX: 742,
                imgY: 487
            },
            {
                img: "concluGarcon",
                imgX: 708,
                imgY: 775
            },
        ]
    },
    screen4: {
        title: {
            text: "Le rétablissement".toUpperCase(),
            config: { size: '48px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        subtitle: {
            text: "Les 4 piliers du rétablissement",
            config: { size: '36px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        consigne: {
            text: "Cliquez sur chaque pilier pour en savoir plus.",
            config: { size: '30px', fontFamily: 'CenturyGothicItalic', align: 'left', color: Colors.Text.TextBlue, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        items: [
            {
                title: {
                    text: "Garder espoir".toUpperCase(),
                    config: { size: '36px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 350 },
                },
                content: {
                    text: "Se projeter dans l'avenir et retrouver confiance en soi.",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 350 },
                },
                illu: "concluEspoir",
            },
            {
                title: {
                    text: "Se reconstruire\naprès le diagnostic".toUpperCase(),
                    config: { size: '36px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 350 },
                },
                content: {
                    text: "Accepter que l'on est malade, mais que la maladie ne résume pas son identité : on peut vivre avec sa maladie et avancer avec elle.",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 350 },
                },
                illu: "concluSeReconstruire",
            },
            {
                title: {
                    text: "Donner un sens\nà sa vie".toUpperCase(),
                    config: { size: '36px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 350 },
                },
                content: {
                    text: "La maladie prend, à un moment, toute la place. Une fois qu'elle a été prise en charge, il s'agit de se fixer des nouveaux objectifs : renouer des liens avec sa famille et ses amis, pratiquer un loisir, reprendre ses études, se réinsérer dans l'emploi, par exemple.",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 350 },
                },
                illu: "concluDonner",
            },
            {
                title: {
                    text: "Se responsabiliser".toUpperCase(),
                    config: { size: '36px', fontFamily: 'DKButterfly', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 350 },
                },
                content: {
                    text: "Être acteur de sa santé et de ses soins et retrouver un pouvoir d'agir activement dans sa vie pour provoquer des changements.",
                    config: { size: '24px', fontFamily: 'CenturyGothic', align: 'center', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0.5, y: 0 }, width: 350 },
                },
                illu: "concluSeResponsabiliser",
            },
        ]
    },
    screen5: {
        title: {
            text: "Le rétablissement".toUpperCase(),
            config: { size: '48px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        subtitle: {
            text: "Pour conclure...",
            config: { size: '36px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1400 },
        },
        content: {
            text: "Le parcours de rétablissement, c’est <class='boldCentury'>passer d’une vie centrée sur la maladie à une vie centrée sur ses projets, ses envies et ses forces</class>, avec un accompagnement adapté (des soignants, des proches…), cela même si des symptômes résiduels persistent.",
            config: { size: '28px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 850 },
        },
        illu: [
            {
                img: "concluPersoRandoEnPied",
                imgX: 1380,
                imgY: 611
            },
            {
                img: "concluSoignant",
                imgX: 1151,
                imgY: 495
            },
            {
                img: "concluFille",
                imgX: 1670,
                imgY: 460
            },
            {
                img: "concluBulleVoyage",
                imgX: 1283,
                imgY: 289
            },
            {
                img: "concluBulleMain",
                imgX: 1537,
                imgY: 317
            },
            {
                img: "concluBulleAmour",
                imgX: 1605,
                imgY: 617
            },
        ]
    },
    screen6: {
        title: {
            text: "Bravo !".toUpperCase(),
            config: { size: '68px', fontFamily: 'DKButterfly', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1000 },
        },
        subtitle: {
            text: "Vous avez terminé de parcourir l'ensemble des ressources du module « Connaissances médicales » de l'e-learning LEO 2.0 !",
            config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1100 },
        },
        content: {
            text: "Vous pouvez, si vous le souhaitez, parcourir à nouveau et à tout moment les ressources de votre choix en fonction de vos besoins.\n\nNous espérons que nous avons répondu à toutes vos questions d'ordre médical.\n\n<class='boldCentury'>Bonne continuation !</class>",
            config: { size: '28px', fontFamily: 'CenturyGothic', align: 'left', color: Colors.Text.Black, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 550 },
        }
    },

}

